import css from '@styled-system/css';
import styled from 'styled-components';
import { alignSelf, border, color, compose, layout, shadow, space } from 'styled-system';
import theme from '../theme';
const List = styled.ul `
  ${css({
    listStyle: 'none',
    my: '2',
    padding: '0',
    width: 'fit-content'
})}
  ${compose(alignSelf, border, color, layout, shadow, space)}
`;
List.defaultProps = { theme };
export default List;
//# sourceMappingURL=List.js.map